const helpers = require('./helpers')

function setUpGoogleTagManagerScripts(timestamp, gtm) {
  const externalSrc = '//www.googletagmanager.com/gtm.js?id='
  if (helpers.hasScriptAlreadyLoaded(externalSrc)) {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'gtm.start': timestamp,
    event: 'gtm.js',
  })

  const scriptElement = document.createElement('script')
  scriptElement.async = true
  scriptElement.src = externalSrc + gtm

  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(scriptElement, firstScript)
  } else {
    document.head.appendChild(scriptElement) // Insert the script into the document head if there's no firstScript.
  }
}

// https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications#tracking_virtual_pageviews
function firePageTracking(path) {
  window.ga('set', 'page', path)
  window.ga('send', 'pageview')
}

module.exports = {
  firePageTracking,
  setUpGoogleTagManagerScripts,
}
